import { render, staticRenderFns } from "./alarm-record.vue?vue&type=template&id=5da90ce4&"
import script from "./alarm-record.vue?vue&type=script&lang=js&"
export * from "./alarm-record.vue?vue&type=script&lang=js&"
import style0 from "./alarm-record.vue?vue&type=style&index=0&id=5da90ce4&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports